import script from "./RequestMixin.vue?vue&type=script&lang=js"
export * from "./RequestMixin.vue?vue&type=script&lang=js"

export default script